import { employeesStore } from '../employeesStore';
import { createStoreDispatcher, type StoreDispatcher } from '../../commands/storeDispatcher';
import type { EmployeeCommand } from './employeeCommands';

let dispatcher: StoreDispatcher<EmployeeCommand> | null = null;
let initialized = false;

export function initEmployeeDispatcher(): StoreDispatcher<EmployeeCommand> {
  if (initialized) return dispatcher!;
  initialized = true;
  dispatcher = createStoreDispatcher<EmployeeCommand>(employeesStore);
  return dispatcher;
}

export function getEmployeeDispatcher(): StoreDispatcher<EmployeeCommand> {
  if (!dispatcher) {
    throw new Error('Employee dispatcher not initialized. Call initEmployeeDispatcher() first.');
  }
  return dispatcher;
}
